import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private envConfig: any;

  constructor() {
    if (typeof (window as any).__env !== 'undefined') {
      this.envConfig = (window as any).__env;
    } else {
      console.error('La configuration n\'est pas encore chargée');
      this.envConfig = null;
    }
  }

  get(key: string): any {
    if (this.envConfig) {
      const currentClient = this.envConfig.currentClient;
      const clientConfig = this.envConfig.clients[currentClient];
      if (clientConfig && clientConfig[key]) {
        return clientConfig[key];
      } else {
        console.error(`Clé de configuration ${key} non trouvée pour le client ${currentClient}`);
        return null;
      }
    } else {
      console.error('Configuration non disponible');
      return null;
    }
  }
}
